import {env} from './env';

// Arc queries

export const AGENTS_LIST = `AGENTS_LIST${env}`;
export const AGENTS_LIST_COUNT = `AGENTS_LIST_COUNT${env}`;
export const BUYERS_LIST = `BUYERS_LIST${env}`;
export const BUYERS_LIST_COUNT = `BUYERS_LIST_COUNT${env}`;
export const BUYERS_LOCATION = `BUYERS_LOCATION${env}`;
export const BUYERS_LOCATION_TOTAL = `BUYERS_LOCATION_TOTAL${env}`;
export const ESCROW_TRACKING = `ESCROW_TRACKING${env}`;
export const ESCROW_TRACKING_LIST = `ESCROW_TRACKING_LIST${env}`;
export const FIRMS_LIST = `FIRMS_LIST${env}`;
export const FIRMS_LIST_COUNT = `FIRMS_LIST_COUNT${env}`;
export const FIRM_ATTACHED_PEOPLE = `FIRM_ATTACHED_PEOPLE${env}`;
export const GET_ALL_TENANTS = `GET_ALL_TENANTS${env}`;
export const GET_AGENT_GROSS_CUMULATIVE = `GET_AGENT_GROSS_CUMULATIVE${env}`;
export const HSC_AGENT_CUMULATIVE = `HSC_AGENT_CUMULATIVE${env}`;
export const GET_PAYMENT_PROPERTIES = `GET_PAYMENT_PROPERTIES${env}`
export const OA_AGENT_PIPELINE = `OA_AGENT_PIPELINE${env}`;
export const OLD_STRIVE_AGENT_PIPELINE = `OLD_STRIVE_AGENT_PIPELINE${env}`;
export const UNASSIGNED_AGENT_PIPELINE = `UNASSIGNED_AGENT_PIPELINE${env}`;
export const AGENT_PIPELINE_BUCKET_PROPERTIES = `AGENT_PIPELINE_BUCKET_PROPERTIES${env}`;
export const PROPERTIES_BY_BUYER_STATE = `PROPERTIES_BY_BUYER_STATE${env}`;
export const GET_PROPERTY_ACCOUNT_NUMBER  = `GET_PROPERTY_ACCOUNT_NUMBER${env}`
export const PROPERTY_UNDERWRITING_TENANTS = `PROPERTY_UNDERWRITING_TENANTS${env}`;
export const SELLERS_LIST = `SELLERS_LIST${env}`;
export const SELLERS_LIST_COUNT = `SELLERS_LIST_COUNT${env}`;
export const STRIVE_AGENT_PIPELINE = `STRIVE_AGENT_PIPELINE${env}`;
export const STRIVE_AGENT_PIPELINE_DETAILS = `STRIVE_AGENT_PIPELINE_DETAILS${env}`;
export const AGENT_COMMISSION_BREAKDOWN_PROCURED = `AGENT_COMMISSION_BREAKDOWN_PROCURED${env}`;
export const AGENT_COMMISSION_BREAKDOWN_PAID = `AGENT_COMMISSION_BREAKDOWN_PAID${env}`;
export const AGENT_COMMISSION_PROCURED = `AGENT_COMMISSION_PROCURED${env}`;
export const AGENT_COMMISSION_PROCURED_ALL = `AGENT_COMMISSION_PROCURED_ALL${env}`;
export const AGENT_COMMISSION_PAID = `AGENT_COMMISSION_PAID${env}`;
export const AGENT_COMMISSION_PAID_ALL = `AGENT_COMMISSION_PAID_ALL${env}`;
export const STRIVE_BUCKETS = `STRIVE_BUCKETS${env}`;
export const STRIVE_BUCKETS_PROPOSALS = `STRIVE_BUCKETS_PROPOSALS${env}`;
export const STRIVE_BUCKETS_DETAILS = `STRIVE_BUCKETS_DETAILS${env}`;
export const STRIVE_FEES = `STRIVE_FEES${env}`;
export const STRIVE_HISTORICAL_PIPELINE = `STRIVE_HISTORICAL_PIPELINE${env}`;
export const STRIVE_HISTORICAL_PIPELINE_SPLIT = `STRIVE_HISTORICAL_PIPELINE_SPLIT${env}`;
export const STRIVE_INVENTORY_V2 = `STRIVE_INVENTORY_V2${env}`;
export const STRIVE_INVENTORY_V3 = `STRIVE_INVENTORY_V3${env}`;
export const STRIVE_INVENTORY_BREAKDOWN_V1 = `STRIVE_INVENTORY_BREAKDOWN_V1${env}`;
export const STRIVE_INVENTORY_NEGUC_V1 = `STRIVE_INVENTORY_NEGUC_V1${env}`;
export const STRIVE_PIPELINE_CLOSED = `STRIVE_PIPELINE_CLOSED${env}`;
export const STRIVE_PIPELINE_CLOSED_SPLIT = `STRIVE_PIPELINE_CLOSED_SPLIT${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE = `STRIVE_PIPELINE_TRANSACTION_TYPE${env}`;
export const STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT = `STRIVE_PIPELINE_TRANSACTION_TYPE_SPLIT${env}`;
export const STRIVE_PIPELINE_V2 = `STRIVE_PIPELINE_V2${env}`;
export const STRIVE_PIPELINE_V2_SPLIT = `STRIVE_PIPELINE_V2_SPLIT${env}`;
export const STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE = `STRIVE_PIPELINE_BY_STATUS_AND_TRANSACTION_TYPE${env}`;
export const STRIVE_QUARTERLY_PIPELINE = `STRIVE_QUARTERLY_PIPELINE${env}`;
export const STRIVE_QUARTERLY_PIPELINE_SPLIT = `STRIVE_QUARTERLY_PIPELINE_SPLIT${env}`;
export const TENANTS_LIST = `TENANTS_LIST${env}`;
export const TENANTS_LIST_COUNT = `TENANTS_LIST_COUNT${env}`;
export const LENDERS_LIST = `LENDERS_LIST${env}`;
export const LENDERS_LIST_COUNT = `LENDERS_LIST_COUNT${env}`;
export const TEXAS_MARKET_TRANSACTIONS = `TEXAS_MARKET_TRANSACTIONS${env}`;
export const TEXAS_MARKET_SHARE = `TEXAS_MARKET_SHARE${env}`;
export const TEXAS_REGION_TRANSACTIONS = `TEXAS_REGION_TRANSACTIONS${env}`;
export const TEXAS_TOTAL_TRANSACTIONS = `TEXAS_TOTAL_TRANSACTIONS${env}`;
export const UNDERWRITING_TENANT_LIST = `UNDERWRITING_TENANT_LIST${env}`;
export const V7_PROPERTIES_LIST = `V7_PROPERTIES_LIST${env}`;
export const V7_PROPERTIES_LIST_LITE = `V7_PROPERTIES_LIST_LITE${env}`;
export const V9_PROPERTIES_LIST = `V9_PROPERTIES_LIST${env}`;
export const V7_ROPERTIES_LENDERLIST = `V7_ROPERTIES_LENDERLIST${env}`
export const V7_PROPERTIES_MAP = `V7_PROPERTIES_MAP${env}`;
export const V7_PROPERTIES_STATS = `V7_PROPERTIES_STATS${env}`;
export const V9_PROPERTIES_STATS = `V9_PROPERTIES_STATS${env}`;
export const V7_PROPERTIES_STATS_ACTIVE = `V7_PROPERTIES_STATS_ACTIVE${env}`;
export const V9_PROPERTIES_STATS_ACTIVE = `V9_PROPERTIES_STATS_ACTIVE${env}`;
export const V7_PROPERTIES_STATS_COUNT = `V7_PROPERTIES_STATS_COUNT${env}`;
export const V9_PROPERTIES_STATS_COUNT = `V9_PROPERTIES_STATS_COUNT${env}`;
export const PROPERTY_DATA = `PROPERTY_DATA${env}`;
export const STATS_BY_STATUS = `STATS_BY_STATUS${env}`;
export const STATS_BY_TYPE = `STATS_BY_TYPE${env}`;
export const STATS_BY_BUYER_STATE = `STATS_BY_BUYER_STATE${env}`;
export const HSC_PIPELINE = `HSC_PIPELINE${env}`;
export const HSC_PIPELINE_FEES = `HSC_PIPELINE_FEES${env}`;
export const HSC_TRACKING = `HSC_TRACKING${env}`;
export const HSC_TRACKING_LIST = `HSC_TRACKING_LIST${env}`;
export const GET_PROPERTY_HISTORY = `GET_PROPERTY_HISTORY${env}`;
export const PRIME_RATES = `Prime_rates${env}`;
export const PROPERTIES_ADDRESS = `PROPERTIES_ADDRESS${env}`;
export const STATS_BY_STATUS_HSC = `STATS_BY_STATUS_HSC${env}`;
export const CLOSING_STATS = `CLOSING_STATS${env}`;
export const HOTLIST_PROPERTIES_BY_EMAIL = `HOTLIST_PROPERTIES_BY_EMAIL${env}`;
export const HOTLIST_PROPERTIES = `HOTLIST_PROPERTIES${env}`;
export const GET_FIRM_NAME = `GET_FIRM_NAME${env}`;
export const VENDOR_LIST = `VENDOR_LIST${env}`;
export const VENDOR_LIST_COUNT = `VENDOR_LIST_COUNT${env}`;
export const VENDOR_TYPES = `VENDOR_TYPES${env}`;
export const GET_TEAM_LICENSES = `GET_TEAM_LICENSES${env}`


export const TEAM_MEMBER_LIST = `TEAM_MEMBER_LIST${env}`;
export const TEAM_MEMBER_LIST_COUNT = `TEAM_MEMBER_LIST_COUNT${env}`;
export const STRIVE_AGENT_FIRST_CLOSING = `STRIVE_AGENT_FIRST_CLOSING${env}`;
export const STRIVE_AGENT_FIRST_LISTING = `STRIVE_AGENT_FIRST_LISTING${env}`;
export const AGENT_EMPLOYEE_LIST = 'AGENT_EMPLOYEE_LIST';
export const UNIQUE_TERRITORIES = `UNIQUE_TERRITORIES${env}`;
export const GET_ALL_PRODUCT_TYPES = `GET_ALL_PRODUCT_TYPES${env}`;
export const GET_MARKETS_BY_PRODUCT_TYPE = `GET_MARKETS_BY_PRODUCT_TYPE${env}`;
export const GET_TERRITORY_CITIES_BY_MARKET = `GET_TERRITORY_CITIES_BY_MARKET${env}`;
export const GET_TERRITORIES_V2_BY_MARKET = `GET_TERRITORIES_V2_BY_MARKET${env}`
export const GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER = `GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER${env}`
export const GET_ZIP_CODES_BY_TERRITORY = `GET_ZIP_CODES_BY_TERRITORY${env}`

export const TEAM_MEMBERS_LIST = `TEAM_MEMBERS_LIST${env}`;
export const TEAM_MEMBERS_LIST_COUNT = `TEAM_MEMBERS_LIST_COUNT${env}`;
export const HSC_MEMBER_LISTING_CLOSING_DATES = `HSC_MEMBER_LISTING_CLOSING_DATES${env}`;
export const GET_YEARLY_TOTAL_COMMISSION = `GET_YEARLY_TOTAL_COMMISSION`;
export const GET_YEARLY_TOTAL_COMMISSION_ALL = `GET_YEARLY_TOTAL_COMMISSION_ALL`;
export const HSC_FOLLOW_UP_COUNT= `HSC_FOLLOW_UP_COUNT${env}`;
export const HSC_AGENTS_COUNT =`HSC_AGENTS_COUNT${env}`;
export const HSC_BUYERS_COUNT = `HSC_BUYERS_COUNT${env}`;
export const HSC_HOTLIST_PROPERTIES = `HSC_HOTLIST_PROPERTIES${env}`;
export const HSC_HOTLIST_AGENTS = `HSC_HOTLIST_AGENTS${env}`;
export const HSC_HOTLIST_INVESTORS = `HSC_HOTLIST_INVESTORS${env}`;
export const HSC_HOTLIST_BUYERS = `HSC_HOTLIST_BUYERS${env}`;
export const HSC_HOTLIST_COURTING = `HSC_HOTLIST_COURTING${env}`;
export const HSC_HOTLIST_FOLLOW_UP = `HSC_HOTLIST_FOLLOW_UP${env}`;
export const HSC_COURTING_COUNT = `HSC_COURTING_COUNT${env}`;
export const HSC_PROPERTIES_COUNT = `HSC_PROPERTIES_COUNT${env}`;
export const HSC_SELLERS_COUNT = `HSC_SELLERS_COUNT${env}`;

// Birthday email queries
export const TEAM_MEMBERS_WITH_BIRTHDAYS_TODAY = `TEAM_MEMBERS_WITH_BIRTHDAYS_TODAY${env}`;

// Anniversary email queries
export const TEAM_MEMBERS_WITH_ANNIVERSARIES_TODAY = `TEAM_MEMBERS_WITH_ANNIVERSARIES_TODAY${env}`;

// Arc email queries

export const JUST_LISTED_JUST_CLOSED_PROPERTY = `JUST_LISTED_JUST_CLOSED_PROPERTY${env}`;
export const NEGOTIATION_UNDER_CONTRACT_PROPERTY = `NEGOTIATION_UNDER_CONTRACT_PROPERTY${env}`;
export const GET_HSC_CLOSINGS = `GET_HSC_CLOSINGS${env}`;
export const GET_REFERRAL_CLOSINGS = `GET_REFERRAL_CLOSINGS${env}`;
export const GET_OFF_MARKET_SELLERS = `GET_OFF_MARKET_SELLERS${env}`;

export const AGENT_TERRITORY_MAPPED_DATA = `AGENT_TERRITORY_MAPPED_DATA${env}`
export const TERRITORY_MASTER = `TERRITORY_MASTER${env}`
export const TERRITORY_AGENT_MAPING = `TERRITORY_AGENT_MAPING${env}`
export const TERRITORY_AGENTS = `TERRITORY_AGENTS${env}`

export const V10_PROPERTIES_LIST = `V10_PROPERTIES_LIST${env}`;
export const V10_PROPERTIES_STATS = `V10_PROPERTIES_STATS${env}`;
export const V10_PROPERTIES_STATS_COUNT = `V10_PROPERTIES_STATS_COUNT${env}`;
export const V7_TERRITORY_FLAG_STATS = `V7_TERRITORY_FLAG_STATS${env}`;
export const V9_TERRITORY_FLAG_STATS = `V9_TERRITORY_FLAG_STATS${env}`;
export const V10_TERRITORY_FLAG_STATS = `V10_TERRITORY_FLAG_STATS${env}`;
export const V9_HOT_LIST_COUNT = `V9_HOT_LIST_COUNT${env}`;
export const V10_HOT_LIST_COUNT = `V10_HOT_LIST_COUNT${env}`;

export const INVESTOR_LIST = `INVESTOR_LIST${env}`;
export const INVESTOR_LIST_COUNT = `INVESTOR_LIST_COUNT${env}`;
export const GET_INVESTOR_PROPERTIES = `GET_INVESTOR_PROPERTIES${env}`;
export const INVESTOR_HOT_LIST_CHECK = `INVESTOR_HOT_LIST_CHECK${env}`;
export const INVESTOR_HOT_LIST_CHECK_DELETED = `INVESTOR_HOT_LIST_CHECK_DELETED${env}`;
export const INVESTOR_HOT_LIST_LIST = `INVESTOR_HOT_LIST_LIST${env}`;
export const INVESTOR_HOT_LIST_COUNT = `INVESTOR_HOT_LIST_COUNT${env}`;

export const GET_PROPERTY_CONTRACT_INFO = `GET_PROPERTY_CONTRACT_INFO${env}`;
export const GET_PROPERTY_OWNERSHIPS = `GET_PROPERTY_OWNERSHIPS${env}`;
export const GET_OWNERSHIP_INVESTORS = `GET_OWNERSHIP_INVESTORS${env}`;
export const GET_INVESTOR_OWNERSHIPS = `GET_INVESTOR_OWNERSHIPS${env}`;
export const CHECK_OWNERSHIP_EXISTS = `CHECK_OWNERSHIP_EXISTS${env}`;

export const WEBSITE_PACKAGE_DOWNLOADS = `WEBSITE_PACKAGE_DOWNLOADS${env}`;
export const PROPERTY_WEBSITE_USERS_V2 = `PROPERTY_WEBSITE_USERS_V2${env}`;

// Public API queries
export const PUBLIC_PROPERTIES_LIST = 'PUBLIC_PROPERTIES_LIST';

// Team member celebration card queries
export const TEAM_MEMBER_BIRTHDAY_CARD_BY_ID = 'TEAM_MEMBER_BIRTHDAY_CARD_BY_ID';
export const TEAM_MEMBER_ANNIVERSARY_CARD_BY_ID = 'TEAM_MEMBER_ANNIVERSARY_CARD_BY_ID';